(() => {
	angular.module('main').directive('fileInput', fileInput);

	fileInput.$inject = ['$parse', 'messageService'];

	function fileInput($parse, messageService) {
		return {
			restrict: 'A',
			link(scope, element, attrs) {
				const model = $parse(attrs.fileInput);
				const isMultiple = attrs.multiple;
				const modelSetter = model.assign;

				element.bind('change', () => {
					const values = [];
					const maxMb = 10; // 10 Mb
					const maxSize = maxMb * 1000 * 1024;

					angular.forEach(element[0].files, item => {
						if (item.size <= maxSize) {
							values.push(item);
							element[0].value = null;
						} else {
							messageService.showToaster('w_0', 'attachments');
							element[0].value = null;
						}
					});

					scope.$evalAsync(() => {
						if (isMultiple) {
							modelSetter(scope, values);
						} else {
							modelSetter(scope, values[0]);
						}
					});
				});
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Elements/fileInput.js